import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {

  isSearchBoxExpanded: boolean;

  onToggleSearchBox($event: boolean): void {
    this.isSearchBoxExpanded = $event;
  }

}
